export default __webpack_public_path__ + "static/media/highlightsPage.2190bc6d.png";